import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IChecklistGroup } from '../_shared/models/checklist/checklist-group.model';
import { IChecklist } from '../_shared/models/checklist/checklist.model';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { CheckmarkComponent } from '../checkmark/checkmark.component';
import { HeadingComponent } from '../heading/heading.component';
import { ContainerComponent } from '../container/container.component';

@Component({
    selector: 'sirius-checklist',
    templateUrl: './checklist.component.html',
    styleUrls: ['./checklist.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CheckmarkComponent, ContainerComponent, HeadingComponent],
    host: {
        '[class.has-one-list]': 'listCount() === 1',
        '[class.has-two-lists]': 'listCount() === 2',
        '[class.has-three-lists]': 'listCount() > 2',
    },
})
export class ChecklistComponent implements IDynamicElement<IChecklist> {
    readonly config = input<IChecklist>();
    readonly groups = input<IChecklistGroup[]>([]);

    protected readonly resolvedGroups = computed<IChecklistGroup[]>(() => this.config()?.groups ?? this.groups());

    protected readonly listCount = computed(() => this.resolvedGroups().length);
}
